// extracted by mini-css-extract-plugin
export default {"container":"contact_container__-Jc9d","social":"contact_social__nYb10","socials":"contact_socials__01qVV","greater":"contact_greater__cqe3I"};